<template lang="pug">
  component(:is="selectComponent(this.$route.params.tipoDocumento)")
</template>
<script>
import DeclaracaoTramiteAutentica from '@/screens/portal/publico/DeclaracaoTramiteAutentica'
import PortariaArrecadacao from '@/screens/portal/publico/PortariaArrecadacao'
import DespachoUnificadoReurb from '@/screens/portal/publico/DespachoUnificadoReurb'
import OficioArrecadacao from '@/screens/portal/publico/OficioArrecadacao'
import TituloCertidao from '@/screens/portal/publico/TituloCertidao'
import DocumentoAssinatura from '@/screens/portal/publico/DocumentoAssinatura'
import PlantaMemorial from '@/screens/portal/publico/PlantaMemorial'

export default {
  methods: {
    selectComponent (tipoDocumento) {
      switch (tipoDocumento) {
        case 'PLANTA':
        case 'MEMORIAL_DESCRITIVO':
          return PlantaMemorial
        case 'PORTARIA_ARRECADACAO':
          return PortariaArrecadacao
        case 'DECLARACAO_TRAMITE':
          return DeclaracaoTramiteAutentica
        case 'MATRICULA_ARRECADACAO':
          return OficioArrecadacao
        case 'CERTIDAO_NEGATIVA_ARRECADACAO':
          return OficioArrecadacao
        case 'TITULO_CERTIDAO':
        case 'TITULO':
          return TituloCertidao
        case 'DOCUMENTO_ASSINATURA':
          return DocumentoAssinatura
        case 'DESPACHO_UNIFICADO_REURB':
          return DespachoUnificadoReurb
        default:
          return PortariaArrecadacao
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/screens/portal/publico/DetalhesConsulta.vue